import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtoshirditaxixab() {



  const cardData =
  {
    keyword: 'Daund to Shirdi Taxi Cab Bus Hire Online Booking',
    heading: 'Sanavi Travels: Daund to Shirdi Taxi Cab Bus Hire Online Booking',
    headingDescription: 'Sanavi Travels offers reliable Daund to Shirdi Taxi, Cab & Bus Hire Online Booking, providing safe, comfortable, and hassle-free transportation for pilgrims, families, and groups traveling from Daund to the holy town of Shirdi. We offer a wide range of well-maintained taxis, cabs, tempo travellers, and AC/non-AC buses to suit individual travelers as well as large groups, ensuring spacious seating, air-conditioning, and a smooth journey. With professional chauffeurs, flexible one-way and round-trip packages, transparent pricing, and easy online booking with 24/7 support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient doorstep pickup in Daund and nearby areas, covering major spiritual attractions such as Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur. Choose Sanavi Travels for trusted Daund to Shirdi taxi, cab, and bus hire services, delivering comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is one of India’s most revered pilgrimage destinations, dedicated to Sai Baba. Millions of devotees from all faiths visit the temple seeking blessings, faith, and inner peace. The well-organized darshan system and sacred aartis create a deeply spiritual experience."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir is the heart of Shirdi, housing the tomb of Sai Baba. Devotees experience profound devotion and calm while offering prayers here, making it the most important shrine within the temple complex."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived and performed miracles. The holy dhuni (sacred fire) burns continuously here, symbolizing faith, protection, and spiritual strength."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a historic place where Sai Baba used to rest on alternate nights. Even today, ceremonial processions are carried out on Thursdays and festival days, preserving age-old traditions."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a tranquil garden where Sai Baba spent time in meditation. It features the sacred Nanda Deep lamp, which has been continuously lit and is believed to bring peace and healing to devotees."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is historically significant as the place where Sai Baba was first welcomed to Shirdi. It marks the beginning of Sai Baba’s spiritual journey in the town."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park that recreates scenes from Sai Baba’s life using statues and traditional settings. It helps visitors understand Sai Baba’s teachings in an engaging and visual way."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage honors one of Sai Baba’s closest disciples. The site reflects deep devotion and the spiritual bond between Sai Baba and his followers."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located near Shirdi, Shani Shingnapur is a famous temple of Lord Shani known for its open-door village tradition. Many devotees visit Shani Shingnapur along with Shirdi for spiritual balance and blessings."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park is a popular recreational attraction near Shirdi, offering water rides, wave pools, and family entertainment. It provides a refreshing leisure option alongside spiritual travel."
  }
]
,



"services": [
  {
    "name": "Daund to Shirdi Taxi Cab Bus Hire Online Booking",
    "description": "Daund to Shirdi Taxi Cab Bus Hire Online Booking provides a complete and convenient transportation solution for devotees and travelers planning a trip to Shirdi. The service offers taxis, cabs, and buses to suit different group sizes, all maintained in excellent condition with clean interiors and comfortable seating. Professional chauffeurs manage highway driving, traffic conditions, and temple-route navigation to ensure timely pickups and safe arrivals. Ideal for families, groups, and pilgrims, this service supports flexible schedules, darshan planning, and easy online booking for a smooth end-to-end travel experience."
  },
  {
    "name": "Daund Shirdi Taxi Booking",
    "description": "Daund Shirdi Taxi Booking offers quick and reliable taxi reservations for passengers traveling from Daund to Shirdi. Air-conditioned taxis with experienced drivers ensure a comfortable and stress-free journey. Suitable for solo travelers, families, and elderly devotees, this service focuses on punctuality, safety, and convenience for temple visits and return travel."
  },
  {
    "name": "Daund Shirdi Cab Hire",
    "description": "Daund Shirdi Cab Hire provides dependable cab rental services designed for pilgrims and tourists. Well-maintained AC cabs with professional chauffeurs ensure smooth driving, comfortable seating, and timely arrivals. Ideal for one-way and round-trip journeys, this service emphasizes comfort, reliability, and peaceful travel for Shirdi darshan."
  },
  {
    "name": "Daund Shirdi Bus Hire",
    "description": "Daund Shirdi Bus Hire offers organized bus rental solutions for group travel, religious tours, and community trips. Spacious buses with comfortable seating and trained drivers ensure safe and coordinated travel for all passengers. This service is ideal for large families, religious groups, and tour organizers planning Shirdi darshan."
  },
  {
    "name": "AC Taxi Daund Shirdi",
    "description": "AC Taxi Daund Shirdi ensures a cool and comfortable ride throughout the journey from Daund to Shirdi. Fully air-conditioned taxis with smooth suspension and clean interiors help reduce travel fatigue. Skilled chauffeurs ensure safe driving and efficient route management, making this option suitable for families, senior citizens, and pilgrims."
  },
  {
    "name": "Affordable Cab Shirdi",
    "description": "Affordable Cab Shirdi provides cost-effective travel options for Daund to Shirdi journeys without compromising safety or comfort. Clean, air-conditioned cabs with experienced drivers ensure a smooth and economical trip. Ideal for budget-conscious travelers, families, and pilgrims seeking reliable transport at reasonable pricing."
  },
  {
    "name": "Chauffeur Driven Service Shirdi",
    "description": "Chauffeur Driven Service Shirdi offers stress-free travel with professional drivers handling navigation, traffic, and scheduling. Comfortable vehicles allow passengers to relax and focus on their pilgrimage or travel plans. Especially suitable for elderly devotees and families, this service emphasizes safety, courtesy, and dependable service."
  },
  {
    "name": "Best Shirdi Transport Daund",
    "description": "Best Shirdi Transport Daund delivers high-quality transportation services with well-maintained vehicles and trained chauffeurs. Whether traveling by taxi, cab, or bus, passengers receive reliable, comfortable, and punctual service. Ideal for families, tourists, and regular pilgrims, this service focuses on customer satisfaction and smooth travel."
  },
  {
    "name": "Online Booking Shirdi",
    "description": "Online Booking Shirdi allows customers to easily book taxis, cabs, or buses for Shirdi travel through a simple and convenient booking process. Users can choose vehicle type, pickup location, travel date, and group size with quick confirmation. This service ensures organized planning, transparency, and hassle-free pilgrimage travel."
  },
  {
    "name": "Railway Pickup Daund",
    "description": "Railway Pickup Daund provides timely and hassle-free pickups from Daund railway station for Shirdi-bound travelers. Drivers track train arrivals to ensure punctual pickups and smooth onward journeys. Comfortable air-conditioned vehicles make this service ideal for pilgrims and tourists arriving by train."
  },
  {
    "name": "Group Travel Shirdi",
    "description": "Group Travel Shirdi offers organized transportation solutions for groups traveling from Daund to Shirdi. Spacious buses and larger vehicles with experienced chauffeurs ensure coordinated travel, comfortable seating, and timely arrivals. Ideal for religious groups, community tours, and family gatherings."
  },
  {
    "name": "Family Travel Shirdi",
    "description": "Family Travel Shirdi is designed to make family journeys safe, comfortable, and convenient. Spacious vehicles with ample luggage space and air-conditioning accommodate all family members easily. Professional drivers ensure smooth driving and flexible schedules, making it ideal for family darshan trips."
  },
  {
    "name": "Outstation Transport Daund",
    "description": "Outstation Transport Daund provides reliable long-distance transport services from Daund to Shirdi and other destinations. Well-maintained vehicles with professional chauffeurs ensure safe highway driving, comfortable seating, and timely arrivals. Suitable for pilgrimages, family trips, and extended travel plans."
  },
  {
    "name": "Sai Darshan Transport",
    "description": "Sai Darshan Transport is specially designed for devotees planning Sai Baba darshan at Shirdi. The service ensures timely departures, convenient temple-area drop-offs, and comfortable return journeys. Experienced drivers help manage darshan schedules smoothly, creating a peaceful and devotional travel experience."
  },
  {
    "name": "Shirdi Travel Service",
    "description": "Shirdi Travel Service offers dedicated transportation solutions for pilgrims and tourists traveling from Daund to Shirdi. Comfortable vehicles with trained chauffeurs ensure smooth travel for darshan, sightseeing, and return trips. This service emphasizes comfort, safety, flexibility, and a calm travel experience."
  }
],
"tableData": [
  ["Daund to Shirdi Taxi Cab Bus Hire Online Booking", "Daund Shirdi Taxi Booking"],
  ["Daund Shirdi Cab Hire", "Daund Shirdi Bus Hire"],
  ["AC Taxi Daund Shirdi", "Affordable Cab Shirdi"],
  ["Chauffeur Driven Service Shirdi", "Best Shirdi Transport Daund"],
  ["Online Booking Shirdi", "Railway Pickup Daund"],
  ["Group Travel Shirdi", "Family Travel Shirdi"],
  ["Outstation Transport Daund", "Sai Darshan Transport"],
  ["Shirdi Travel Service", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Daund to Shirdi Taxi Cab Bus Hire Online Booking with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers easy and reliable online booking for Daund to Shirdi taxi cab and bus hire services, perfect for pilgrims, family trips, group travel, and outstation journeys."
  },
  {
    "WhyChooseheading": "Seamless Online Booking",
    "WhyChoosedescription": "Book your taxi cab or bus from Daund to Shirdi conveniently through our user-friendly online platform or by contacting our 24x7 support team."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced taxis and buses to ensure a smooth and enjoyable journey from Daund to Shirdi."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Daund to Shirdi route, ensuring safe, timely, and pleasant travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for online bookings of taxi cabs and buses from Daund to Shirdi, inclusive of fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with online bookings, travel queries, route updates, and itinerary planning."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for online booking of Daund to Shirdi taxi cab and bus hire services."
  }
]

}

const faqData = [
  {
    question: 'Can I book a taxi cab or bus from Daund to Shirdi online?',
    answer: 'Yes, Sanavi Travels offers seamless online booking for both taxi cabs and buses from Daund to Shirdi.'
  },
  {
    question: 'What types of vehicles are available for Daund to Shirdi travel?',
    answer: 'You can choose from taxis (sedans, SUVs, premium cars) or buses depending on your group size and travel requirements.'
  },
  {
    question: 'Are drivers experienced with the Daund to Shirdi route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Daund to Shirdi route to ensure a safe journey.'
  },
  {
    question: 'How do I book online for Daund to Shirdi taxi cab or bus?',
    answer: 'You can book through our website’s online booking form or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Is pricing transparent with no hidden charges?',
    answer: 'Absolutely. All pricing for online bookings from Daund to Shirdi includes fuel, tolls, and driver allowances with no hidden costs.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock online booking support and travel assistance for Daund to Shirdi services.'
  },
  {
    question: 'Are the vehicles sanitized before the trip?',
    answer: 'Yes, all taxis and buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24×7 customer support team is available throughout your Daund to Shirdi trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh More',
    feedback: 'Booked a taxi from Daund to Shirdi online. Easy booking, comfortable ride, and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Patil',
    feedback: 'Great experience hiring a bus online for our Daund to Shirdi trip. Timely service and excellent customer support.',
    rating: 5
  }
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Shirdi Taxi Cab Bus Hire Online Booking - Sanavi Travels",
  "description": "Book AC and chauffeur-driven cabs and buses from Daund to Shirdi with Sanavi Travels. Ideal for Sai Baba darshan, family travel, group trips, railway pickups, outstation journeys, and safe, comfortable transport services.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Daund to Shirdi Taxi Cab Bus Hire Online Booking | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and chauffeur-driven cabs and buses from Daund to Shirdi with Sanavi Travels. Perfect for Sai Baba darshan, family travel, group trips, railway pickups, outstation journeys, and safe, comfortable transport services."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/176.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtoshirditaxixab;